const labelChangeClass = (id, value) => {
        if(value == ""){
          document.getElementById(id).className = "normalLabel";
        }else{
          document.getElementById(id).className = "validLabel";
        }

}

const labelTextareaChangeClass = (id, value) => {
    if(value == ""){
      document.getElementById(id).className = "normalLabelTextarea";
    }else{
      document.getElementById(id).className = "validLabelTextarea";
    }

}

export {labelChangeClass, labelTextareaChangeClass};

